<sd-breadcrumb *ngIf="crumbs$ | async as crumbs; else skeleton" [crumbs]="crumbs"></sd-breadcrumb>
<ng-template #skeleton>
  <nav aria-label="Breadcrumbs">
    <div class="skeleton"></div>
  </nav>
</ng-template>
